import { useRef, useEffect } from 'react';

import styled from 'styled-components';

import { getVisibleHeight } from '@utils/browser';

export const CardListItems = (props) => {
  const ref = useRef();
  useEffect(() => {
    window.requestAnimationFrame(() => {
      if (ref && ref.current) {
        const ht = getVisibleHeight() - ref.current.getBoundingClientRect().top - 24;
        ref.current.style.maxHeight = ht + 'px';
      }
    });
  });

  return <StyledCardListItems ref={ref} {...props} />;
};

export const CardList = styled.div((p) => ({
  position: 'relative',
  flexShrink: 0,
  ...(p.noHeader && {
    paddingTop: p.theme.spacing.m8,
  }),
  backgroundColor: p.theme.colors.purpleTrans5,
  borderRadius: '0.25rem',
  borderColor: 'transparent',
  borderWidth: '0.125rem',
  borderStyle: 'dashed',
  width: '17.5rem',
  height: 'auto',
  maxHeight: '100%',
  display: 'flex',
  flexDirection: 'column',

  ...(p.transparent && {
    backgroundColor: 'transparent',
    borderColor: p.theme.colors.purpleTrans10,
  }),
}));

export const CardListHeader = styled.div((p) => ({
  minHeight: '3.5rem',
  padding: '0.5rem 0.5rem 0.5rem 1rem',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

const StyledCardListItems = styled.div((p) => ({
  position: 'relative',
  '> *:not(:last-child)': {
    marginBottom: p.theme.spacing.m8,
  },
  '> *:is(:last-child)': {
    marginBottom: '0.5rem',
  },
  padding: '0 0.5rem',
  flexGrow: 1,
  overflowY: 'auto',
}));
